import React, { useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Forms } from "../utils/api";

const TABS = [
    { key: "supplier", short: "Nhà cung cấp", label: "Đăng ký nhà cung cấp" },
    { key: "love", short: "Kết nối", label: "Đăng ký kết nối yêu thương" },
    { key: "feedback", short: "Góp ý", label: "Góp ý - Phản ánh" },
    { key: "guide", short: "Hướng dẫn", label: "Hướng dẫn chung" },
];

function cx(...a) {
    return a.filter(Boolean).join(" ");
}

function SectionTitle({ title, desc }) {
    return (
        <div className="mb-4">
            <h1 className="text-white text-xl font-semibold tracking-tight">{title}</h1>
            {desc ? <p className="text-white/60 text-sm mt-1 leading-5">{desc}</p> : null}
        </div>
    );
}

function Field({ label, value, onChange, placeholder, type = "text", inputMode, autoComplete, maxLength }) {
    return (
        <label className="block">
            <div className="text-white/80 text-sm mb-1.5">{label}</div>
            <input
                type={type}
                inputMode={inputMode}
                autoComplete={autoComplete}
                maxLength={maxLength}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full rounded-xl bg-white/5 border border-white/10 px-3.5 py-3 text-white placeholder:text-white/30 outline-none
                   focus:border-white/25 focus:bg-white/7 transition"
            />
        </label>
    );
}

function TextArea({ label, value, onChange, placeholder, rows = 4, maxLength }) {
    return (
        <label className="block">
            <div className="text-white/80 text-sm mb-1.5">{label}</div>
            <textarea
                rows={rows}
                maxLength={maxLength}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full rounded-xl bg-white/5 border border-white/10 px-3.5 py-3 text-white placeholder:text-white/30 outline-none
                   focus:border-white/25 focus:bg-white/7 transition resize-none"
            />
        </label>
    );
}

function PillTabs({ tab, onChange }) {
    return (
        <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
            {TABS.map((t, idx) => {
                const active = tab === t.key;
                return (
                    <button
                        key={t.key}
                        onClick={() => onChange(t.key)}
                        className={cx(
                            "shrink-0 rounded-full px-3.5 py-2 text-sm border transition",
                            active
                                ? "bg-white text-black border-white"
                                : "bg-white/5 text-white/80 border-white/10 hover:bg-white/10"
                        )}
                    >
                        <span className="font-semibold mr-1">{idx + 1}.</span>
                        {t.short}
                    </button>
                );
            })}
        </div>
    );
}

function Card({ children }) {
    return (
        <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur px-4 py-4 shadow-[0_10px_40px_rgba(0,0,0,0.35)]">
            {children}
        </div>
    );
}

function SubmitButton({ loading, label, onClick }) {
    return (
        <button
            disabled={loading}
            onClick={onClick}
            className={cx(
                "w-full rounded-xl py-3.5 font-semibold transition",
                "bg-red-600 text-white hover:bg-red-500",
                "disabled:opacity-60 disabled:cursor-not-allowed"
            )}
        >
            <span className="inline-flex items-center justify-center gap-2">
                {loading ? (
                    <span className="inline-block h-4 w-4 rounded-full border-2 border-white/30 border-t-white animate-spin" />
                ) : null}
                {label}
            </span>
        </button>
    );
}


function GuideAccordion() {
    return (
        <div className="space-y-3 text-white/85 text-sm leading-6">
            <details className="rounded-xl border border-white/10 bg-white/5 px-3.5 py-3" open>
                <summary className="cursor-pointer font-semibold text-white">
                    1. Khi tìm 61 dịch vụ
                </summary>
                <div className="mt-2 space-y-1">
                    <div>• Từ 1 đến 45: Quý khách nên chọn theo <b>Xã</b></div>
                    <div>• Từ 46 đến 60: Quý khách nên chọn theo <b>Tỉnh</b></div>
                    <div>• Dịch vụ 61: Quý khách nên chọn theo <b>Huyện</b></div>
                </div>
            </details>

            <details className="rounded-xl border border-white/10 bg-white/5 px-3.5 py-3">
                <summary className="cursor-pointer font-semibold text-white">
                    2. Khi đăng ký dịch vụ
                </summary>
                <div className="mt-2 space-y-1">
                    <div>• Dịch vụ 1–45: chọn theo <b>Xã</b> rồi đăng ký</div>
                    <div>• Dịch vụ 46–60: chọn theo <b>Tỉnh</b> rồi đăng ký</div>
                    <div>• Dịch vụ 61: chọn theo <b>Huyện</b> rồi đăng ký</div>
                </div>
            </details>

            <details className="rounded-xl border border-white/10 bg-white/5 px-3.5 py-3">
                <summary className="cursor-pointer font-semibold text-white">
                    3. Tra sổ lô tô
                </summary>
                <div className="mt-2 space-y-1">
                    <div>• Vào mục “Tra sổ lô tô” ở thanh dưới</div>
                    <div>• Điền số điện thoại của bạn</div>
                    <div>• Nhấn OK</div>
                </div>
            </details>

            <details className="rounded-xl border border-white/10 bg-white/5 px-3.5 py-3">
                <summary className="cursor-pointer font-semibold text-white">
                    4. Bé học đá banh
                </summary>
                <div className="mt-2 space-y-1">
                    <div>• Mỗi Huyện có 3–6 sân banh</div>
                    <div>• Quý phụ huynh liên hệ trực tiếp với thầy sân banh gần nhà</div>
                    <div>• Mỗi sân 14–20 cháu, độ tuổi 5–10</div>
                    <div>• Lớp bố trí theo cùng độ tuổi</div>
                    <div>• 60 phút/buổi học:</div>
                    <div className="pl-4">- 5 phút đầu: khởi động</div>
                    <div className="pl-4">- 30 phút kế: học kỹ thuật</div>
                    <div className="pl-4">- 25 phút cuối: chia 2 đội đá</div>
                </div>
            </details>
        </div>
    );
}

export default function RegisterGuidePage() {
    const [tab, setTab] = useState("supplier");
    const [submitting, setSubmitting] = useState(false);
    const formRef = useRef(null);

    const [supplier, setSupplier] = useState({
        supplierName: "",
        contactName: "",
        phone: "",
        address: "",
        product: "",
    });

    const [love, setLove] = useState({
        fullName: "",
        gender: "",
        birthYear: "",
        maritalStatus: "",
        height: "",
        weight: "",
        phone: "",
        education: "",
        province: "",
        specialty: "",
        currentJob: "",
        partnerRequest: "",
    });

    const [feedback, setFeedback] = useState({
        content: "",
        phone: "",
        name: "",
    });

    const tabMeta = useMemo(() => TABS.find((t) => t.key === tab), [tab]);

    const goTab = (k) => {
        setTab(k);
        // cuộn nhẹ xuống form cho mobile
        requestAnimationFrame(() => {
            formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    };

    async function submit(type, payload) {
        try {
            setSubmitting(true);
            await Forms.submit({ type, payload });
            toast.success("Đã gửi. Cảm ơn bạn!");
        } catch (e) {
            toast.error(e?.message || "Gửi thất bại");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="min-h-[calc(100svh-64px)] bg-gradient-to-b from-black via-zinc-950 to-black">
            <div className="max-w-xl mx-auto px-4 py-5">
                <SectionTitle
                    title="Đăng ký & Hướng dẫn"
                    desc="Chọn mục phù hợp, điền thông tin và gửi. Hệ thống sẽ chuyển về mục Thông báo cho bộ phận quản trị."
                />

                <Card>
                    <PillTabs tab={tab} onChange={goTab} />
                </Card>

                <div className="h-4" />

                <div ref={formRef} />

                <Card>
                    <div className="mb-3">
                        <div className="text-white font-semibold">{tabMeta?.label}</div>
                        <div className="text-white/60 text-sm mt-1">
                            {tab === "guide"
                                ? "Xem hướng dẫn nhanh."
                                : "Vui lòng nhập thông tin chính xác để chúng tôi liên hệ."}
                        </div>
                    </div>

                    {tab === "supplier" ? (
                        <div className="space-y-3">
                            <Field
                                label="Tên nhà cung cấp *"
                                value={supplier.supplierName}
                                onChange={(v) => setSupplier((s) => ({ ...s, supplierName: v }))}
                                placeholder="Ví dụ: Cửa hàng Khanh"
                                autoComplete="organization"
                            />
                            <Field
                                label="Người liên hệ"
                                value={supplier.contactName}
                                onChange={(v) => setSupplier((s) => ({ ...s, contactName: v }))}
                                placeholder="Ví dụ: Nguyễn Văn A"
                                autoComplete="name"
                            />
                            <Field
                                label="Số điện thoại *"
                                value={supplier.phone}
                                onChange={(v) => setSupplier((s) => ({ ...s, phone: v }))}
                                placeholder="Nhập số điện thoại"
                                type="tel"
                                inputMode="numeric"
                                autoComplete="tel"
                                maxLength={15}
                            />
                            <Field
                                label="Địa chỉ"
                                value={supplier.address}
                                onChange={(v) => setSupplier((s) => ({ ...s, address: v }))}
                                placeholder="Ví dụ: Ấp..., Xã..., Huyện..."
                                autoComplete="street-address"
                            />
                            <TextArea
                                label="Sản phẩm / Dịch vụ muốn cung cấp"
                                value={supplier.product}
                                onChange={(v) => setSupplier((s) => ({ ...s, product: v }))}
                                placeholder="Ví dụ: thực phẩm, đồ chơi, dịch vụ..."
                                rows={3}
                                maxLength={500}
                            />

                            <SubmitButton
                                loading={submitting}
                                label="Gửi đăng ký"
                                onClick={() => {
                                    if (!supplier.supplierName.trim()) return toast.error("Vui lòng nhập tên nhà cung cấp");
                                    if (!supplier.phone.trim()) return toast.error("Vui lòng nhập số điện thoại");
                                    submit("supplier", supplier);
                                    setSupplier({ supplierName: "", contactName: "", phone: "", address: "", product: "" });
                                }}
                            />
                        </div>
                    ) : null}

                    {tab === "love" ? (
                        <div className="space-y-3">
                            <Field
                                label="Họ và tên *"
                                value={love.fullName}
                                onChange={(v) => setLove((s) => ({ ...s, fullName: v }))}
                                placeholder="Ví dụ: Nguyễn Văn A"
                                autoComplete="name"
                            />
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <Field
                                    label="Giới tính"
                                    value={love.gender}
                                    onChange={(v) => setLove((s) => ({ ...s, gender: v }))}
                                    placeholder="Nam / Nữ"
                                />
                                <Field
                                    label="Năm sinh"
                                    value={love.birthYear}
                                    onChange={(v) => setLove((s) => ({ ...s, birthYear: v }))}
                                    placeholder="Ví dụ: 1995"
                                    inputMode="numeric"
                                    maxLength={4}
                                />
                            </div>

                            <Field
                                label="Tình trạng hôn nhân"
                                value={love.maritalStatus}
                                onChange={(v) => setLove((s) => ({ ...s, maritalStatus: v }))}
                                placeholder="Độc thân / Ly hôn / ..."
                            />

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <Field
                                    label="Chiều cao"
                                    value={love.height}
                                    onChange={(v) => setLove((s) => ({ ...s, height: v }))}
                                    placeholder="Ví dụ: 1m65"
                                />
                                <Field
                                    label="Cân nặng"
                                    value={love.weight}
                                    onChange={(v) => setLove((s) => ({ ...s, weight: v }))}
                                    placeholder="Ví dụ: 60kg"
                                />
                            </div>

                            <Field
                                label="Số điện thoại *"
                                value={love.phone}
                                onChange={(v) => setLove((s) => ({ ...s, phone: v }))}
                                placeholder="Nhập số điện thoại"
                                type="tel"
                                inputMode="numeric"
                                autoComplete="tel"
                                maxLength={15}
                            />

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <Field
                                    label="Học vấn"
                                    value={love.education}
                                    onChange={(v) => setLove((s) => ({ ...s, education: v }))}
                                    placeholder="Ví dụ: 12/12, CĐ, ĐH..."
                                />
                                <Field
                                    label="Hiện ở tỉnh"
                                    value={love.province}
                                    onChange={(v) => setLove((s) => ({ ...s, province: v }))}
                                    placeholder="Ví dụ: Long An"
                                />
                            </div>

                            <Field
                                label="Nghề chuyên môn"
                                value={love.specialty}
                                onChange={(v) => setLove((s) => ({ ...s, specialty: v }))}
                                placeholder="Ví dụ: công nhân may, QC..."
                            />
                            <Field
                                label="Công việc hiện tại"
                                value={love.currentJob}
                                onChange={(v) => setLove((s) => ({ ...s, currentJob: v }))}
                                placeholder="Ví dụ: đang làm tại..."
                            />

                            <TextArea
                                label="Yêu cầu về người muốn kết đôi"
                                value={love.partnerRequest}
                                onChange={(v) => setLove((s) => ({ ...s, partnerRequest: v }))}
                                placeholder="Ví dụ: độ tuổi, tính cách, nơi ở..."
                                rows={4}
                                maxLength={800}
                            />

                            <SubmitButton
                                loading={submitting}
                                label="Gửi đăng ký"
                                onClick={() => {
                                    if (!love.fullName.trim()) return toast.error("Vui lòng nhập họ và tên");
                                    if (!love.phone.trim()) return toast.error("Vui lòng nhập số điện thoại");
                                    submit("love", love);
                                    setLove({
                                        fullName: "",
                                        gender: "",
                                        birthYear: "",
                                        maritalStatus: "",
                                        height: "",
                                        weight: "",
                                        phone: "",
                                        education: "",
                                        province: "",
                                        specialty: "",
                                        currentJob: "",
                                        partnerRequest: "",
                                    });
                                }}
                            />
                        </div>
                    ) : null}

                    {tab === "feedback" ? (
                        <div className="space-y-3">
                            <Field
                                label="Họ tên (không bắt buộc)"
                                value={feedback.name}
                                onChange={(v) => setFeedback((s) => ({ ...s, name: v }))}
                                placeholder="Ví dụ: Nguyễn Văn A"
                                autoComplete="name"
                            />
                            <Field
                                label="Số điện thoại (không bắt buộc)"
                                value={feedback.phone}
                                onChange={(v) => setFeedback((s) => ({ ...s, phone: v }))}
                                placeholder="Nhập số điện thoại"
                                type="tel"
                                inputMode="numeric"
                                autoComplete="tel"
                                maxLength={15}
                            />
                            <TextArea
                                label="Nội dung góp ý / phản ánh *"
                                value={feedback.content}
                                onChange={(v) => setFeedback((s) => ({ ...s, content: v }))}
                                placeholder="Bạn hãy mô tả rõ nội dung để bộ phận phụ trách xử lý nhanh."
                                rows={6}
                                maxLength={1200}
                            />

                            <SubmitButton
                                loading={submitting}
                                label="Gửi"
                                onClick={() => {
                                    if (!feedback.content.trim()) return toast.error("Vui lòng nhập nội dung góp ý");
                                    submit("feedback", feedback);
                                    setFeedback({ content: "", phone: "", name: "" });
                                }}
                            />
                        </div>
                    ) : null}

                    {tab === "guide" ? (
                        <GuideAccordion />
                    ) : null}
                </Card>

                <div className="h-10" />
            </div>
        </div>
    );
}
